import { getAccessToken } from "./auth";
import { encryptSMSRequest, decryptSMSResponse } from "./smsEncryption";
export async function sendMobileOTP(mobileNumber) {
  try {
    const enc = await encryptSMSRequest({ mobileNumber });
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/send-sms-otp",
      {
        method: "POST",
        headers: {
          "Authorization": "Basic " + btoa("prabhudasu:root"),
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response:", errorText);
      throw new Error(
        `Failed to send mobile OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;

  } catch (error) {
    console.error("Error sending mobile OTP:", error);
    return {
      status: 400,
      message: Liferay.Language.get("failed-to-send-otp-please-try-again"),
      success: false,
      error: error.message || Liferay.Language.get("failed-to-send-otp")
    };
  }
}


export async function verifyMobileOTP(payload) {
  try {
    const enc = await encryptSMSRequest(payload);
    const response = await fetch(
      "/o/mhdbt-headless-service/v1.0/verify-sms-otp",
      {
        method: "POST",
        headers: {
          "Authorization": "Basic " + btoa("prabhudasu:root"),
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          encryptedPayload: enc.encryptedPayload,
          signature: enc.signature,
          iv: enc.iv
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Verify OTP Error:", errorText);
      throw new Error(
        `Failed to verify OTP. Status: ${response.status}`
      );
    }

    const data = await response.json();
    if (data.encryptedResponse && data.iv) {
      return await decryptSMSResponse(data.encryptedResponse, data.iv, enc._aesKey);
    }
    return data;

  } catch (error) {
    console.error("Error verifying OTP:", error, error.message);
    return {
      statusCode: 400,
      message: Liferay.Language.get("verification-failed-please-try-again"),
      success: false,
      error: error.message || Liferay.Language.get("verification-failed-please-try-again")
    };
  }
}
